<template>
  <div
    :class="containerClass"
    :data-testid="dataTestid"
  >
    <div :class="textAlignClass">
      <span class="text-semantic-inverse-primary font-bold">
        Select a product
      </span>
      to get started
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8 w-full">
      <V2MoleculesCardHeroCard
        v-for="card in visibleCards"
        :id="card.trackingId"
        :key="card.trackingId"
        :image-path="card.icon"
        :title="card.label"
        :to="card.pageUrl"
        :target="card.target"
        :data-testid="tileTestId(card)"
        @click="trackTileClick(card)"
      />
    </div>

    <div
      v-if="cards.length > 8"
      class="flex justify-center w-full"
    >
      <V2AtomsButton
        theme="tertiary"
        size="small"
        class="text-semantic-primary-on-default no-underline hover:text-semantic-primary-on-default"
        :inverted="true"
        @click="toggleShowMore"
      >
        {{ buttonText }}

        <template #icon-right="{ iconClass }">
          <V2IconsArrowCircle
            :class="[iconClass, 'h-6 w-6']"
            :fill="semanticColorLookup('inverse.primary')"
            :direction="showMore ? 'top' : 'bottom'"
          />
        </template>
      </V2AtomsButton>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'MoleculesHomeCardItems'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'home-card-btn'
  },

  cards: {
    type: Array,
    default: () => [],
    required: false
  },

  position: {
    type: String,
    default: 'center',
    validator: v => ['left', 'center', 'right'].includes(v)
  }
})

const { cards, position } = toRefs(props)
const showMore = ref(false)

const containerClass = computed(() => [
  'md:max-w-wrapper-sm flex flex-col gap-4',
  position.value === 'left'
    ? 'text-left mr-auto'
    : position.value === 'right'
      ? 'text-right ml-auto'
      : 'text-center mx-auto'
])

const textAlignClass = computed(() => {
  const positionClass =
    position.value === 'left'
      ? 'text-left'
      : position.value === 'right'
        ? 'text-right'
        : 'text-center'
  return [
    'text-semantic-inverse-on-surface md:text-sm/[150%] md:mt-16 mt-8',
    positionClass
  ]
})

const buttonText = computed(() =>
  showMore.value ? 'View less products' : 'View more products'
)
const visibleCards = computed(() =>
  showMore.value ? cards.value : cards.value.slice(0, 8)
)

function toggleShowMore () {
  showMore.value = !showMore.value
}

function tileTestId (card) {
  const slug = card.trackingId.replace(/^home_tile_/, '').replace(/_/g, '-')
  return `home-tile-${slug}-btn`
}

function trackTileClick (card) {
  if (!import.meta.client) return

  const { $tracking } = useNuxtApp()
  $tracking?.trackedClick(card.trackingId, {
    elementId: card.trackingId,
    elementInnerText: card.label,
    elementButtonUrl: card.pageUrl
  })
}
</script>
